import React, { Component } from 'react';
import { 
  ArrowIcon
} from './SVGIcons';
import SearchPopup from './SearchPopup';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSearchPopup: false
    };
  }

  openSearchPopup = () => {
    this.setState({ showSearchPopup: true });
  };

  closeSearchPopup = () => {
    this.setState({ showSearchPopup: false });
  };

  render() {
    const data = this.props?.data || {};
    const { showSearchPopup } = this.state;

    return (
      <>
        <div className='flex lg:max-w-[500px] lg:left-[calc(50%-250px)] lg:rounded-t-[10px] fixed items-center justify-between px-[10px] bottom-0 w-full font-medium z-[20] bg-[#032432]/80 backdrop-blur-2xl pb-[20px] lg:pb-0 h-[75px] lg:h-[55px] gap-[5px] text-[10px] text-white/70'>
          <a href="/" className='flex items-center justify-center flex-col gap-[3px]'>
            <div className='flex items-center justify-center h-[20px] flex-none'>
              <svg className='flex-none' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.765 2.13012L2.7225 5.28012C2.0475 5.80512 1.5 6.92262 1.5 7.77012V13.3276C1.5 15.0676 2.9175 16.4926 4.6575 16.4926H13.3425C15.0825 16.4926 16.5 15.0676 16.5 13.3351V7.87512C16.5 6.96762 15.8925 5.80512 15.15 5.28762L10.515 2.04012C9.465 1.30512 7.7775 1.34262 6.765 2.13012Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M9 13.4927V11.2427" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div>Главная</div>
          </a>
          
          {/* Кнопка поиска */}
          <button
            onClick={this.openSearchPopup}
            className='flex items-center justify-center flex-col gap-[3px] bg-transparent border-0 cursor-pointer'
          >
            <span className='flex items-center justify-center h-[20px] flex-none'>
              <svg className='flex-none' width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.51449 14.529C11.3885 14.529 14.529 11.3885 14.529 7.51449C14.529 3.6405 11.3885 0.5 7.51449 0.5C3.6405 0.5 0.5 3.6405 0.5 7.51449C0.5 11.3885 3.6405 14.529 7.51449 14.529Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14.7451 14.7465L12.832 12.8335" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
            <span>Поиск</span>
          </button>

          {/* Кнопка Запросить КП */}
          <button
            onClick={() => this.props.showKviz()}
            className='flex items-center justify-center gap-[9px] h-[36px] bg-[#009EE3] rounded-full px-[25px] hover:bg-[#0077b3] transition-colors duration-300 border-0 cursor-pointer'
          >
            <span className='text-white text-[12px] whitespace-nowrap'>Запросить КП</span>
            <ArrowIcon />
          </button>

          <a href={data?.katalog_link} className='flex items-center justify-center flex-col gap-[3px]'>
            <div className='flex items-center justify-center h-[20px] flex-none'>
              <svg className='flex-none' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.25 6.39143V5.5831C6.25 3.7081 7.75833 1.86643 9.63333 1.69143C11.8667 1.47476 13.75 3.2331 13.75 5.42476V6.57476" stroke="white" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7.49937 18.3337H12.4994C15.8494 18.3337 16.4494 16.992 16.6244 15.3587L17.2494 10.3587C17.4744 8.32533 16.891 6.66699 13.3327 6.66699H6.66603C3.1077 6.66699 2.52437 8.32533 2.74937 10.3587L3.37437 15.3587C3.54937 16.992 4.14937 18.3337 7.49937 18.3337Z" stroke="white" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M12.9121 9.99967H12.9196" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M7.07615 9.99967H7.08364" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div>Каталог</div>
          </a>
          
          <a href={data?.kontakti_link} className='flex items-center justify-center flex-col gap-[3px]'>
            <div className='flex items-center justify-center h-[20px] flex-none'>
              <svg className='flex-none' width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.4775 13.7475C16.4775 14.0175 16.4175 14.295 16.29 14.565C16.1625 14.835 15.9975 15.09 15.78 15.33C15.4125 15.735 15.0075 16.0275 14.55 16.215C14.1 16.4025 13.6125 16.5 13.0875 16.5C12.3225 16.5 11.505 16.32 10.6425 15.9525C9.78 15.585 8.9175 15.09 8.0625 14.4675C7.2 13.8375 6.3825 13.14 5.6025 12.3675C4.83 11.5875 4.1325 10.77 3.51 9.915C2.895 9.06 2.4 8.205 2.04 7.3575C1.68 6.5025 1.5 5.685 1.5 4.905C1.5 4.395 1.59 3.9075 1.77 3.4575C1.95 3 2.235 2.58 2.6325 2.205C3.1125 1.7325 3.6375 1.5 4.1925 1.5C4.4025 1.5 4.6125 1.545 4.8 1.635C4.995 1.725 5.1675 1.86 5.3025 2.055L7.0425 4.5075C7.1775 4.695 7.275 4.8675 7.3425 5.0325C7.41 5.19 7.4475 5.3475 7.4475 5.49C7.4475 5.67 7.395 5.85 7.29 6.0225C7.1925 6.195 7.05 6.375 6.87 6.555L6.3 7.1475C6.2175 7.23 6.18 7.3275 6.18 7.4475C6.18 7.5075 6.1875 7.56 6.2025 7.62C6.225 7.68 6.2475 7.725 6.2625 7.77C6.3975 8.0175 6.63 8.34 6.96 8.73C7.2975 9.12 7.6575 9.5175 8.0475 9.915C8.4525 10.3125 8.8425 10.68 9.24 11.0175C9.63 11.3475 9.9525 11.5725 10.2075 11.7075C10.245 11.7225 10.29 11.745 10.3425 11.7675C10.4025 11.79 10.4625 11.7975 10.53 11.7975C10.6575 11.7975 10.755 11.7525 10.8375 11.67L11.4075 11.1075C11.595 10.92 11.775 10.7775 11.9475 10.6875C12.12 10.5825 12.2925 10.53 12.48 10.53C12.6225 10.53 12.7725 10.56 12.9375 10.6275C13.1025 10.695 13.275 10.7925 13.4625 10.92L15.945 12.6825C16.14 12.8175 16.275 12.975 16.3575 13.1625C16.4325 13.35 16.4775 13.5375 16.4775 13.7475Z" stroke="white" strokeMiterlimit="10"/>
                <path d="M13.875 6.75C13.875 6.3 13.5225 5.61 12.9975 5.0475C12.5175 4.53 11.88 4.125 11.25 4.125" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M16.5 6.75C16.5 3.8475 14.1525 1.5 11.25 1.5" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div>Контакты</div>
          </a>
        </div>

        {/* Поиск */}
        <SearchPopup
          show={showSearchPopup}
          onClose={this.closeSearchPopup}
        />
      </>
    );
  }
}

export default App;